import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setImages(r.data.images)).catch(() => {});
  }, []);

  // Bento layout assignments
  const layout = [
    "md:col-span-8 md:row-span-2 aspect-square md:aspect-auto",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-6 aspect-[4/3]",
  ];

  return (
    <section id="gallery" className="bg-[#050505] py-24 md:py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#FF3333]" />
              <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">03 — Gallery</span>
            </div>
            <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
              The <span className="italic text-[#FF3333]">Work</span>
            </h2>
          </div>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer"
            className="text-xs uppercase tracking-[0.25em] text-white/60 hover:text-[#FF3333] transition-colors"
          >
            → Follow on Instagram
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[260px]">
          {images.map((src, i) => (
            <div
              key={i}
              data-testid={`gallery-img-${i}`}
              className={`relative overflow-hidden group ${layout[i % layout.length]}`}
            >
              <img
                src={src}
                alt={`Cut ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
